import { AxiosResponse } from "axios";
import instance from "../instance";
interface TokenResponse {
  access: number;
  token: string;
}
export const getToken = async (initData: string) => {
  try {
    const response: AxiosResponse<TokenResponse> = await instance.post(
      `${import.meta.env.VITE_BASE_API_URL}/auth/messenger/telegram/`,
      {
        initData: initData,
      }
    );

    const token = response.data.token;
    sessionStorage.setItem("auth_token", token);
    instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    return response.data.access;
  } catch (error) {
    console.error("Failed to get token:", error);
    throw error;
  }
};
